(ns hypnos.consumer.specs
  "Specs"
  (:require [clojure.spec.alpha :as s]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Regular Expressions

(def ^{:const true} email-regex
  #"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$")

(def ^{:const true} phone-number-regex
  #"([2-9][0-8][0-9])([2-9][0-9]{2})([0-9]{4})")

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Specs

;; common specs
(s/def ::dirty? boolean?)
(s/def ::touched? boolean?)
(s/def ::weight (s/and int? #(< 49 % 501)))
(s/def ::genders #{:gender/female :gender/male :gender/unknown})
(s/def ::sleep-positions #{:sleep-position/back
                           :sleep-position/side
                           :sleep-position/stomach
                           :sleep-position/upright})
(s/def ::issues #{:issue/breathing
                  :issue/claustrophobic
                  :issue/eye
                  :issue/forehead
                  :issue/face
                  :issue/nose})

;; consult
(s/def :weight/value (s/nilable ::weight))
(s/def :consult/weight (s/keys :req-un [:weight/value ::dirty? ::touched?]))
